import { render } from "./InputTextAreaCustom.vue?vue&type=template&id=598dc912"
import script from "./InputTextAreaCustom.vue?vue&type=script&lang=js"
export * from "./InputTextAreaCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__